import BaseHttp from './BaseHttp';
import moment from 'moment';
import config from '../../config/app.config';
class CarsAPI extends BaseHttp {
    constructor(config) {
        super();
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "getMyCarsList", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (offset, limit, sort, search, imagesByApp) => this.privateRequest('get', 'user/car', { sort, offset, limit, search, imagesByApp })
        });
        // Load vehicle data object by internal auto.de ID
        Object.defineProperty(this, "getCarData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id, withJWT) => {
                if (withJWT) {
                    return this.privateRequest('get', `user/car/${id}`)
                        .then((response) => response.data);
                }
                return this.request('get', `car/${id}`)
                    .then((response) => response.data);
            }
        });
        Object.defineProperty(this, "getVehicleId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (vehicleId) => {
                return this.request('get', `car/${vehicleId}/autodeId`)
                    .then((response) => {
                    // console.log('response', response);
                    return response.data;
                });
            }
        });
        // Load vehicle data object using third party data provider
        Object.defineProperty(this, "getCarDataByDatGroupID", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (datGroupID) => {
                return this.request('get', `datgroup/${datGroupID}`)
                    .then((response) => {
                    return response.data;
                });
            }
        });
        Object.defineProperty(this, "getCarDataByVIN", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (vinCode) => this.privateRequest('get', `vin/${vinCode}`)
                .then((response) => response.data)
        });
        Object.defineProperty(this, "removeCarFromCarList", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (carID) => this.privateRequest('delete', `car/${carID}`)
                .then((response) => response.data)
        });
        Object.defineProperty(this, "updateCarData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id, newData) => {
                return this.privateRequest('put', `car/${id}`, newData)
                    .then((response) => {
                    return response.data;
                });
            }
        });
        Object.defineProperty(this, "createCar", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (car) => {
                return this.privateRequest('post', 'car', car);
            }
        });
        Object.defineProperty(this, "synchronizeCars", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (userId) => {
                return this.privateRequest('post', `user/${userId}/car/synchronize`);
            }
        });
        Object.defineProperty(this, "getOnlineCars", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (startTime, endTime) => {
                return this.privateRequest('get', `car/firstonline/${startTime}/${endTime}`)
                    .then((response) => {
                    return response.data;
                });
            }
        });
        Object.defineProperty(this, "setMarkCarAsNew", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (carId) => {
                const newData = {
                    data: {
                        metaData: {
                            creationDate: moment().unix()
                        }
                    },
                    additional: {
                        shouldUpdateFirstIsOnline: true
                    }
                };
                return this.privateRequest('put', `car/${carId}`, newData)
                    .then((response) => {
                    return response.data;
                });
            }
        });
        this.setConfig(config);
    }
}
export default new CarsAPI({
    baseURL: config.carsAPI.url
});
